import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const SquareButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { ZwibblerUseRectangleTool, isRectangleEnabled, isZoomed, ZwibblerEnableReadOnlyMode } =
    rootStore.zwibblerStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    if(isRectangleEnabled)ZwibblerEnableReadOnlyMode();
    else ZwibblerUseRectangleTool();
  };

  return (
    <>
      <Button
        id="square"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          isRectangleEnabled
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        color=""
        disabled={isZoomed}
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i className="far fa-square iconToolbarButton"></i>

        <h6 className="textToolbarButton mb-0">{t("toolbar_square_button")}</h6>
      </Button>
    </>
  );
};

export default observer(SquareButton);
